export const dashboardStepState = () => ({
  isFirstStepComplete: false
});
